import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import {
  DeleteOutline,
  EditOutlined,
  PhotoLibraryOutlined,
} from "@mui/icons-material";

interface VenueCardActionsProps {
  venueId: number;
  canEdit: boolean;
  canDelete: boolean;
  canChangeCover?: boolean;
  primaryColor: string;
  onEdit: (venueId: number) => void;
  onDelete: (venueId: string) => void;
  onChangeCover: () => void;
}

export const VenueCardActions: React.FC<VenueCardActionsProps> = ({
  venueId,
  canEdit,
  canDelete,
  primaryColor,
  onEdit,
  onDelete,
  onChangeCover,
  canChangeCover,
}) => {
  if (!canEdit && !canDelete) return null;

  return (
    <Box
      className="card-actions"
      sx={{
        position: "absolute",
        top: 12,
        right: 12,
        display: "flex",
        gap: 1,
        opacity: 0,
        pointerEvents: "none",
        transition: "all 0.3s ease",
        zIndex: 3,
      }}
    >
      {canEdit && (
        <Tooltip title="Edit Venue" arrow>
          <IconButton
            aria-label="edit"
            size="small"
            onClick={() => onEdit(venueId)}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              color: primaryColor,
              backdropFilter: "blur(10px)",
              "&:hover": {
                backgroundColor: primaryColor,
                color: "white",
                transform: "scale(1.1)",
              },
            }}
          >
            <EditOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {canDelete && (
        <Tooltip title="Delete Venue" arrow>
          <IconButton
            aria-label="delete"
            size="small"
            onClick={() => onDelete(venueId.toString())}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              color: "#f44336",
              backdropFilter: "blur(10px)",
              "&:hover": {
                backgroundColor: "#f44336",
                color: "white",
                transform: "scale(1.1)",
              },
            }}
          >
            <DeleteOutline fontSize="small" />
          </IconButton>
        </Tooltip>
      )}

      {canChangeCover && (
        <Tooltip title="Change Cover Photo" arrow>
          <IconButton
            size="small"
            onClick={onChangeCover}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              color: primaryColor,
              backdropFilter: "blur(10px)",
              "&:hover": {
                backgroundColor: primaryColor,
                color: "white",
                transform: "scale(1.1)",
              },
            }}
          >
            <PhotoLibraryOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default VenueCardActions;
